const services = [
  {
    id: 'service-catering',
    title: 'Indoor & Outdoor Catering',
    type: 'catering',
    bulletPoints: [
      'Custom menus for events of any size',
      'Service crew, setup, plating, and clean up',
      'Tableware and buffet stations handled end-to-end',
    ],
    cta: 'Book a tasting',
    link: '/services?tab=catering',
  },
  {
    id: 'service-rentals',
    title: 'Cooking Utensil Rentals',
    type: 'rental',
    bulletPoints: ['Large pots & burners for big events', 'Mini kits for private dinners', 'Sanitized and delivered to venue'],
    cta: 'Reserve utensils',
    link: '/services?tab=rental',
  },
  {
    id: 'service-shop',
    title: 'Flagship Shop',
    type: 'shop',
    bulletPoints: ['Open daily for walk-in orders', 'Limited seating indoor/outdoor', 'Takeaway + delivery from FMC Line shop 1, Asaba, Delta State'],
    cta: 'Visit shop',
    link: '/services?tab=shop',
  },
];

export default services;
